import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { UserApi } from 'api';

function useGet(id: string, enabled = true) {
  return useAuthQuery(getQueryKeys([KEY]).detail(id), () => UserApi.get(id), {
    select: (data) => data.data,
    enabled,
  });
}

export default useGet;
